import SignUpRecordService from '../sign-up-record-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {purchaseProjectStatus} from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  mixins: [purchaseProjectStatus],
  data() {
    return {
      qualificationReview: [], // 资格审核
      purchaseCategory: [], // 项目分类
      total: 0,
      tableList: [],
      searchForm: {
        projectName: '',
        projectCode: '',
        qualificationReview: '',
        projectType: '',
        pageNum: 1,
        pageSize: 5
      }
    };
  },
  created() {
    const arr = [
      // ['qualificationReview', 'QUALIFICATION_REVIEW'],
      ['purchaseCategory', 'PURCHASE_PROJECT_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = [{code: '', value: '全部'}, ...res.data];
        }
      });
    });
    this.getSignUpRecordList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 序号计算
    indexMethod(index) {
      return (Number(this.searchForm.pageNum) - 1) * Number(this.searchForm.pageSize) + index + 1;
    },
    // 获取我的报名采购标的列表
    getSignUpRecordList(page){
      // this.tableList = [];
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      SignUpRecordService.getSignUpRecordList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    clear () {
      this.searchForm = {
        projectName: '',
        projectCode: '',
        qualificationReview: '',
        projectType: '',
        pageNum: 1,
        pageSize: 5
      };
      this.getSignUpRecordList();
    },
    goToDetail (id) {
      this.$router.push('/person-center/purchase-business/purchase-project/audit-apply/list?id=' + id);
    }
  }
};
